import { ref, computed, watch } from "vue";
import { isArray } from "../../_utils/is.js";
const useColumnFilter = (props, emit) => {
  var _a;
  const { dataIndex, filterable } = props.column;
  const filterPopupVisible = ref(false);
  const isFilterActive = computed(() => isArray(props.filterValue) && props.filterValue.length > 0);
  const isMultipleFilter = computed(() => Boolean(filterable == null ? void 0 : filterable.multiple));
  const columnFilterValue = ref((_a = props.filterValue) != null ? _a : []);
  watch(() => props.filterValue, (value) => {
    if (isArray(value) && String(value) !== String(columnFilterValue.value)) {
      columnFilterValue.value = value;
    }
  });
  const handleFilterPopupVisibleChange = (value) => {
    filterPopupVisible.value = value;
  };
  const setFilterValue = (filterValue) => {
    columnFilterValue.value = filterValue;
  };
  const handleCheckboxFilterChange = (values) => {
    setFilterValue(values);
  };
  const handleRadioFilterChange = (value) => {
    setFilterValue([value]);
  };
  const handleFilterConfirm = (e) => {
    emit("filterChange", dataIndex, columnFilterValue.value, e);
    handleFilterPopupVisibleChange(false);
  };
  const handleFilterReset = (e) => {
    setFilterValue([]);
    emit("filterChange", dataIndex, columnFilterValue.value, e);
    handleFilterPopupVisibleChange(false);
  };
  return {
    filterPopupVisible,
    isFilterActive,
    isMultipleFilter,
    columnFilterValue,
    handleFilterPopupVisibleChange,
    setFilterValue,
    handleCheckboxFilterChange,
    handleRadioFilterChange,
    handleFilterConfirm,
    handleFilterReset
  };
};
export { useColumnFilter };
